export enum DEFAULT_LANGUAGE {
  ar = "Arabic",
  en = "English",
  es = "Spanish",
  fr = "French",
  ru = "Russian",
  ch = "Chinese",
  ko = "Korean",
}
